import Tanamas1 from '../../Media/Produk/Tanamas.webp'
import Tanamas2 from '../../Media/Produk/Tanamas.webp'



const Tanamasimages =[
    Tanamas1,Tanamas2
]

export default Tanamasimages;